import React from "react";
import { createPortal } from "react-dom";

const RootPortal: React.FC<React.PropsWithChildren<unknown>> = ({ children }) =>
  // const appRoot = document.getElementById("root");

  // return appRoot && createPortal(children, appRoot);
  createPortal(children, document.body);
export default RootPortal;
